import './Button.css';

const Button = ({
  variant = "primary",
  loading = false,
  disabled = false,
  fullWidth = false,
  // 🛡️ Par défaut "button" : un <button> natif sans type vaut "submit" et soumettrait
  // le <form> parent au moindre clic (cause de créations de réservation involontaires).
  // Les vrais boutons de soumission passent explicitement type="submit".
  type = "button",
  children,
  className = "",
  ...props
}) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${loading ? "loading" : ""} ${fullWidth ? "w-full" : ""} ${className}`}
      disabled={disabled || loading}
      {...props}   // safe because fullWidth was removed
    >
      {loading ? "Chargement..." : children}
    </button>
  );
};

export default Button;
